export const handleSubmitForm = (values, mutateUpload) => {
  const uploadData = {
    mobileBrandImage: values.mobileBrandImage ? values.mobileBrandImage[0] : null,
    mobileBrandId: values.mobileBrandId,
    mobileBrandCode: values.mobileBrandCode,
    mobileBrandNameTh: values.mobileBrandNameTh,
    mobileBrandNameEn: values.mobileBrandNameEn,
  };

  mutateUpload(uploadData);
};
